export function getMimeType(fileName) {
  const extension = fileName?.split(".")?.pop()?.toLowerCase();

  const mimeTypes = {
    pdf: "application/pdf",
  };

  return extension ? mimeTypes[extension] : "application/octet-stream";
}
